import React from 'react';
import {CircularProgress} from '@material-ui/core';

export const LoadingIcon = (props) => <CircularProgress color="inherit" size={props.size}/>